import { render } from "./VesselSummary.vue?vue&type=template&id=16b97130"
import script from "./VesselSummary.vue?vue&type=script&lang=js"
export * from "./VesselSummary.vue?vue&type=script&lang=js"

import "./VesselSummary.vue?vue&type=style&index=0&id=16b97130&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/smartsim-ui-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__